import { render, staticRenderFns } from "./DSArrowReturnIcon.vue?vue&type=template&id=2a8c7f18&"
import script from "./DSArrowReturnIcon.vue?vue&type=script&lang=js&"
export * from "./DSArrowReturnIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports